/**
 * Created by Fernando Torres on 01/02/2018.
 */
import DealersListView from '@/views/app/dealers/dealers-list-view'
import DealersView from '@/views/app/dealers/dealers-view'
import DealersCreateView from '@/views/app/dealers/dealers-create-view'
import DealersEditView from '@/views/app/dealers/dealers-edit-view'
import store from '@/store'

export default [
  {
    path: 'dealers',
    name: 'dealers',
    component: DealersListView,
    children: [
      {
        path: 'create',
        name: 'dealers-create',
        component: DealersCreateView
      },
      {
        path: ':id/edit',
        name: 'dealers-edit',
        component: DealersEditView
      }
    ],
    beforeEnter (to, from, next) {
      let profile = store.getters['profile/me']
      if (profile.role === 'dealer_chief') {
        next({name: 'dealers-view', params: {id: profile.dealerId}})
      } else {
        next()
      }
    }
  },
  {
    path: 'dealers/:id',
    name: 'dealers-view',
    component: DealersView
  }
]



// WEBPACK FOOTER //
// ./src/router/app/dealers/index.js